<template>
  <div>
    <b-badge
      style="float: right; width: 50%"
      :key="index"
      v-for="(val, index) in pazaryeriLogo(params.value)"
    > 
      <img
        :src="findPazaryeri(val)"
        style="width: 100%; float: right"
        class="img-fluid"
        v-b-tooltip.hover.bottom="val.program"
      />
    </b-badge>
  </div>
</template>
<script>
export default {
  methods: {
    StringToXML(oString) {
      //code for IE
      if (window.ActiveXObject) {
        var oXML = new ActiveXObject("Microsoft.XMLDOM");
        oXML.loadXML(oString);
        return oXML;
      }
      // code for Chrome, Safari, Firefox, Opera, etc.
      else {
        return new DOMParser().parseFromString(oString, "text/xml");
      }
    },
    xml2json(xml) {
      try {
        var obj = {};

        if (xml.children.length > 0) {
          for (var i = 0; i < xml.children.length; i++) {
            var item = xml.children.item(i);
            var nodeName = item.nodeName;

            if (typeof obj[nodeName] == "undefined") {
              obj[nodeName] = this.xml2json(item);
            } else {
              if (typeof obj[nodeName].push == "undefined") {
                var old = obj[nodeName];

                obj[nodeName] = [];
                obj[nodeName].push(old);
              }
              obj[nodeName].push(this.xml2json(item));
            }
          }
        } else {
          obj = xml.textContent;
        }
        return obj;
      } catch (e) {
        console.log(e.message);
      }
    },
    pazaryeriLogo(gelen) {
      let s = [];

      try {
        s = JSON.parse(gelen);
      } catch (error) {
        var parseString = this.StringToXML(gelen);
        let deger = [];
        let olusturulan = {};
        deger = this.xml2json(parseString);
        s = deger.programlar.program;

        if (typeof s.length == "undefined") {
          s = [s];
        }
      }
      try {
        let k = "";
        let logo = "";
        let array = [];
        if (typeof s != "undefined")
          s.forEach(element => {
            const program =
              typeof element == "string" ? element : element.program;

            array.push({
              program,
              satisDurum: element.satisDurum
            });
          });

        // k = element.program + " / " +  element.gonderilecekFiyat + " / " +  element.gonderilecekAdet + " - " +   k;
        return array;
      } catch (error) {}
    },
    findPazaryeri(gelen) {
      try {
        const logoMap = {
          Hepsiburada: "hepsiburada.png",
          Trendyol: "trendyol.png"
        };
        const program = gelen.program.trim();
        const fileName = logoMap[program] || program + ".png";

        return require("../../../assets/images/logo/" +
          fileName);
      } catch (error) {}
    }
  }
};
</script>
